module.exports = __webpack_public_path__ + "static/media/aurelien.29a904d0.jpg";